import Marquee from "react-fast-marquee";

const items = [
  "One on One Mentorship",
  "10,000+ Dentists Trained",
  "Clinical Excellence",
  "Celebrity Smiles",
  "Porcelain Veneers",
  "Mastering Smile Transformations",
];

export const EditorialMarquee = ({ dark = false }) => (
  <div
    className={`py-5 ${dark ? "bg-[#0E0E0E]" : "bg-[#FAFAF8] border-y border-[#0E0E0E]/10"}`}
    data-testid="editorial-marquee"
  >
    <Marquee speed={30} gradient={false} autoFill>
      {items.map((item) => (
        <span key={item} className="flex items-center">
          <span
            className={`font-heading font-semibold text-lg lg:text-xl px-8 ${dark ? "text-[#FAFAF8]" : "text-[#0E0E0E]"}`}
          >
            {item}
          </span>
          <span className="text-[#C6A45C] text-lg">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);
